import {
  type CrossResourceAvailabilityRuleId,
  isSupplierAvailableFromGrants,
} from "../../shared/rbac/crossResourceAvailability";
import type { GrantRow } from "../../shared/rbac/grantQueries";

// The suppliers a space can use: every current member with space access can also
// reach them. This is what the Connectors/Skills/Networks cards in space settings
// show. A space with no grants has no members, so nothing is usable — without
// this guard isSupplierAvailableFromGrants reads a grantless dependent as
// vacuously available and every supplier would appear.
export function usableSuppliersForSpace<
  T extends { roleGrantsAsScope: readonly GrantRow[] },
>(
  ruleId: CrossResourceAvailabilityRuleId,
  spaceGrants: readonly GrantRow[],
  suppliers: readonly T[],
  memberships: ReadonlyMap<string, readonly string[]>
): T[] {
  if (spaceGrants.length === 0) return [];
  return suppliers.filter((s) =>
    isSupplierAvailableFromGrants(
      ruleId,
      spaceGrants,
      s.roleGrantsAsScope,
      memberships
    )
  );
}
